import { render, staticRenderFns } from "./Objects.vue?vue&type=template&id=cb0a4688&scoped=true&"
import script from "./Objects.vue?vue&type=script&lang=js&"
export * from "./Objects.vue?vue&type=script&lang=js&"
import style0 from "./Objects.vue?vue&type=style&index=0&id=cb0a4688&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a4688",
  null
  
)

export default component.exports